import { Link } from "react-router-dom";
import { useTranslation } from "../components/Localization";

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="screen not-found">
      <h1>{t("notFound.title")}</h1>
      <Link className="outline-button" to="/">
        {t("notFound.home")}
      </Link>
    </main>
  );
}
